import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import MedicineList from "./MedicineList";
import Pronunciations from "./Pronunciations";
import Medicines from "./Medicines";

const TABS = [["list", "Medicine list", MedicineList], ["pronunciations", "Pronunciations", Pronunciations], ["patients", "Patient medicines", Medicines]];

export default function MedicinesHub() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.some(([k]) => k === sp.get("tab")) ? sp.get("tab") : "list";
  return (
    <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })} data-testid="medicines-hub">
      <TabsList className="mb-4 flex-wrap">
        {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`medicines-tab-${k}`}>{l}</TabsTrigger>)}
      </TabsList>
      {TABS.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
    </Tabs>
  );
}
